/** Admin route path constants used by navigation and route matching. */
export const adminRoutePaths = {
    appInfo: '/admin/get-app-info',
    permissions: '/administrace/opravneni',
    roles: '/administrace/role',
    roleDetail: '/administrace/role/:id',
    users: '/administrace/uzivatele',
    usersDetail: '/administrace/uzivatele/:id',
    breederManagement: '/administrace/spravce-subjektu',
};
